const columns = [
  {
    key: "deviceCode",
    zh: "整机编号",
    en: "Device Code",
    width: "14%"
  },
  {
    key: "company",
    zh: "公司名称",
    en: "Company",
    width: "19%"
  },
  {
    key: "model",
    zh: "机型",
    en: 'Model',
    width: "10%"
  },
  {
    key: "exhaustPressure",
    zh: "排气压力(MPa)",
    en: "Exhaust Pressure(MPa)",
    width: "22%"
  },
  {
    key: "exhaustTemperature",
    zh: "排气温度(℃)",
    en: "Exhaust Temperature(℃)",
    width: "22%",
    tooltip: true
  },
  {
    key: "oilInletTemperature",
    zh: "进油温度(℃)",
    en: "Oil Inlet Temperature(℃)",
    width: "13%",
    tooltip: true
  }
]

export default columns